module.exports = __webpack_public_path__ + "img/appsAttacks.897a29b.svg";